<template>
  <div class="search">
    <form onsubmit="return false" @submit="handleSearch">
      <!--suppress HtmlFormInputWithoutLabel -->
      <input type="search" :title="$t('searchDApps')" :placeholder="$t('searchDApps')" value="" required>
      <button>
        <a-icon type="search"></a-icon>
      </button>
    </form>
  </div>
</template>

<script>
  import * as router from '../router'

  export default {
    name: 'DAppSearchBox',
    props: ['searchHandler'],
    methods: {
      handleSearch (event) {
        const keywords = event.target[0].value
        if (this.searchHandler) {
          this.searchHandler(keywords)
        } else {
          router.navigateToSearch(keywords)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "./../utils";

  $height: 46px;

  .search {
    background-color: white;
    border: 1px solid #DDDDDD;
    border-radius: 100px;
    height: $height;

    form {
      height: $height;
      display: flex;
      flex-direction: row;
    }

    input, button {
      border: none;
      outline: none;
      margin: 0;
      padding: 0;
      height: $height;
      line-height: $height;
      background: transparent;
    }
    input::placeholder {
      color: #999999;
    }
    input {
      padding-left: 15px;
      font-size: $height * 0.4;
      width: 0;
      flex-grow: 1;
    }
    button {
      width: $height;
      font-size: $height * 0.55;
    }
  }
</style>



// WEBPACK FOOTER //
// src/widgets/DAppSearchBox.vue